import React from "react";
import { useTranslation } from 'react-i18next';
import DefaultLayout from "../../layouts/DefaultLayout";
import "./Contact.css";

const Contact = () => {
  const { t } = useTranslation();
  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult(t("sending"));
    const formData = new FormData(event.target);

    formData.append("access_key", "9c0c40b7-46c7-4ed5-a9f0-7a06f23eb9ea");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult(t("successMessage"));
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(t("errorMessage"));
    }
  };
  return (
    <DefaultLayout>
      <div className="contact-container">
        <h1>{t('contactUs')}</h1>
        <p>
          {t('contactDescription')}
        </p>
        <form className="contact-form" onSubmit={onSubmit}>
          <label htmlFor="name">{t('name')}</label>
          <input type="text" id="name" name="name" required />

          <label htmlFor="email">{t('email')}</label>
          <input type="email" id="email" name="email" required />

          <label htmlFor="message">{t('message')}</label>
          <textarea id="message" name="message" rows="5" required></textarea>

          <button type="submit">{t('send')}</button>
        </form>
        <span>{result}</span>
      </div>
    </DefaultLayout>
  );
};

export default Contact;
